export default [{
	//首页登录页面,如果是演示系统就会启用特殊配置
	path: '/',
	name: 'home',
	component: () => import('@/page/home.vue')
},
	{
		//天澄定制看板
		path: '/unitBoard',
		name:'unitBoard',
		component: () =>
			//import('@/page/unitKanBan/temp.vue')
			import('@/page/unitKanBan/TcKanBan1.vue')
		//import('@/page/unitKanBan/demo1.vue')
	},]
